"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var useMemoizedFn_1 = __importDefault(require("../useMemoizedFn"));
var useUpdate_1 = __importDefault(require("../useUpdate"));
function useControlValue(options) {
  var value = options.value,
    defaultValue = options.defaultValue,
    onChange = options.onChange;
  var update = (0, useUpdate_1["default"])();
  // @ts-ignore
  var stateRef = (0, react_1.useRef)(value !== undefined ? value : defaultValue);
  if (value !== undefined) {
    stateRef.current = value;
  }
  var setState = (0, useMemoizedFn_1["default"])(function (v, forceTrigger) {
    // @ts-ignore
    var nextValue = typeof v === 'function' ? v(stateRef.current) : v;
    if (!forceTrigger && nextValue === stateRef.current) return;
    stateRef.current = nextValue;
    update();
    onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
  });
  return [stateRef.current, setState];
}
exports["default"] = useControlValue;